import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
//UI
import HomeLayout from '../../../layouts/HomeLayout';
import MainLoader from '../../../components/Loaders/MainLoader';
import InputForm from '../../../components/Inputs/formInput/InputForm';
import BtnContent from '../../../components/buttons/BtnContent';
import HeaderForm from '../../../components/headers/catalogs/HeaderForm';
import DropdownForm from '../../../components/Inputs/formInput/DropdonwForm';
import Error from '../../../components/errors/Error';
//SLICES
import { getRolesThunk } from '../../../store/slices/catalogs/roles.slice';
import { getUserThunk, initialStateUser, updateUserThunk, createUserThunk } from '../../../store/slices/catalogs/users.slice';
import ImageUploader from '../../../components/Inputs/formInput/InputImageUpload';
import TextAreaForm from '../../../components/Inputs/formInput/TextAreaForm';
import { getEventThunk, createEventThunk, updateEventThunk, initialStateEvent } from '../../../store/slices/catalogs/events.slice';
import { formatDateForm } from '../../../utils/funtions';
import { API_BASE_URL } from '../../../store/constans';



const EventsForm = () => {
    const { t } = useTranslation();
    let { event_id } = useParams();
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const { setValue, register, handleSubmit, formState: { errors } } = useForm();
    const { event, message, error } = useSelector(state => state.events);
    const isLoading = useSelector(state => state.isLoadingSlice);
    const [background, setBackground] = useState(null);
    const [backgroundFile, setBackgroundFile] = useState(null);

    useEffect(() => {
        if (event_id) {
            dispatch(getEventThunk(event_id));
        }
        return () => {
            dispatch(initialStateEvent());
        };
    }, []);

    useEffect(() => {
        if (event_id) {
            setBackground(API_BASE_URL + event.imagen);
            setValue('name', event?.name)
            setValue('date', formatDateForm(event?.fecha))
            setValue('time', event?.hora)
            setValue('location', event?.locacion)
            setValue('description', event?.descripcion)
        }
    }, [event, setValue]);

    const onSubmit = useCallback((data) => {
        const formData = new FormData();
        formData.append('name', data.name);
        formData.append('date', data.date);
        formData.append('time', data.time);
        formData.append('location', data.location);
        formData.append('description', data.description);

        if (backgroundFile) formData.append('imagen', backgroundFile);

        if (event_id) {
            dispatch(updateEventThunk(event_id, formData));
        } else {
            dispatch(createEventThunk(formData));
        }
    }, [event, backgroundFile, dispatch]);

    const removeBackground = () => {
        setBackground(null);
        setBackgroundFile(null);
    }

    if (message === "Registro creado correctamente " || message === "Registro actualizado correctamente ") {
        navigate(`/panel/events`);
    }

    return (
        <HomeLayout>
            {isLoading ? (
                <MainLoader />
            ) : (
                <div className="w-[96%] mt-5 ml-5 ">
                    {error ? <Error state={error} /> : " "}
                    <HeaderForm title={event_id ? "Editar evento" : "Nuevo evento"} />
                    <div className='h-[90%] overflow-y-scroll contenedor'>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='flex gap-2 p-2'>
                                <InputForm
                                    spam={true}
                                    label={t("user_name")}
                                    input="input"
                                    type="text"
                                    cols={1}
                                    register={register("name", { required: true })}
                                    placeholder={t("user_name")}
                                    errors={errors.name && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                            </div>
                            <div className='flex gap-2 p-2'>
                                <InputForm
                                    type="date"
                                    label={t("Fecha")}
                                    input="input"
                                    spam={true}
                                    cols={1}
                                    register={register("date", { required: true })}
                                    errors={errors.date && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                                <InputForm
                                    type="text"
                                    label={t('Hora')}
                                    input="input"
                                    spam={true}
                                    cols={1}
                                    register={register("time", { required: true })}
                                    errors={errors.time && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                                <InputForm
                                    type="text"
                                    label={t('Lugar')}
                                    input="input"
                                    spam={true}
                                    cols={1}
                                    register={register("location", { required: true })}
                                    errors={errors.location && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                            </div>
                            <div className='flex gap-2 p-2'>
                                <TextAreaForm
                                    type="textarea"
                                    label={t("Descripción")}
                                    input="input"
                                    spam={true}
                                    cols={1}
                                    register={register("description", { required: true })}
                                    errors={errors.description && (<span className="text-red-500 text-xs">{t("required_information")}</span>)}
                                />
                                <ImageUploader
                                    image={background}
                                    setImage={setBackground}
                                    removeImage={removeBackground}
                                    spam
                                    label={t("Imagen de evento")}
                                    register={register}
                                    name="imagen"
                                    setValue={setBackgroundFile}
                                    errors={!background && !backgroundFile && <span className="text-red-500 text-xs">{t("required_information")}</span>}
                                />
                            </div>
                            <div className="flex items-center justify-start py-5 gap-2 border-t-2 border-p-green mt-8">
                                <BtnContent type="submit">{t("save_button")}</BtnContent>
                                <BtnContent cancel={true} to={`/panel/events`}>{t("canceled_button")}</BtnContent>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default EventsForm;